import { PKCE_COOKIE_NAME, STATE_COOKIE_NAME, IS_SIGNING_OUT_COOKIE_NAME, AUTH_FLOW_PROOF_MAX_AGE, REMOVE_COOKIE_MAX_AGE } from '../constant.mjs';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createSignInFlowProofCookies = ({ state, pkce, }) => [
    {
        name: PKCE_COOKIE_NAME,
        value: pkce,
    },
    {
        name: STATE_COOKIE_NAME,
        value: state,
    },
];
const createSignOutFlowProofCookies = () => [
    {
        name: IS_SIGNING_OUT_COOKIE_NAME,
        value: 'true',
    },
];
const createAuthFlowProofCookiesSetOptions = (setCookieOptions, overrides) => ({
    domain: setCookieOptions?.domain,
    path: '/',
    httpOnly: true,
    secure: overrides?.secure ?? true,
    sameSite: 'lax',
    maxAge: AUTH_FLOW_PROOF_MAX_AGE,
});
const createAuthFlowProofCookiesRemoveOptions = (setCookieOptions) => ({
    domain: setCookieOptions?.domain,
    path: '/',
    maxAge: REMOVE_COOKIE_MAX_AGE,
});

export { createAuthFlowProofCookiesRemoveOptions, createAuthFlowProofCookiesSetOptions, createSignInFlowProofCookies, createSignOutFlowProofCookies };
//# sourceMappingURL=authFlowProofCookies.mjs.map
